import { render, staticRenderFns } from "./auckland.vue?vue&type=template&id=fe987fdc&scoped=true"
import script from "./auckland.vue?vue&type=script&lang=js"
export * from "./auckland.vue?vue&type=script&lang=js"
import style0 from "./auckland.vue?vue&type=style&index=0&id=fe987fdc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe987fdc",
  null
  
)

export default component.exports